import { render, staticRenderFns } from "./InstrumentInfoForm.vue?vue&type=template&id=485ddd24&"
import script from "./InstrumentInfoForm.vue?vue&type=script&lang=js&"
export * from "./InstrumentInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./InstrumentInfoForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports